import React from 'react';
import { IconButton, IconButtonProps } from "@mui/material";
import { useSnackbar } from '../common/SnackbarContext';


type CopyToClipboardProps = {
    TextToCopy: string;
    AckMessage: string;
    // Then use : const ConnexionTabs: React.FC<TabStateProps> = (props) => {
} & IconButtonProps


export const CopyToClipboard: React.FC<CopyToClipboardProps> = (props: CopyToClipboardProps) => {

    const { TextToCopy, AckMessage, children, ...others } = props;
    const { showSnackbar } = useSnackbar();

    const handleClick: any = () => {
        copyText(TextToCopy)
            .then(() => showSnackbar(AckMessage))
            .catch(err => console.log(err));
        
        async function copyText(targetText: string): Promise<boolean> {
            await navigator.clipboard.writeText(targetText);
            return true;
        }
    };

    if (!TextToCopy || TextToCopy.trim() === '' || TextToCopy.trim() === 'null') {
        return (<>?&nbsp;</>)
    }

    return (
        <IconButton onClick={e => { handleClick(); e.stopPropagation(); }} {...others} >
            {children}
        </IconButton>
    );
};